<template>
  <div class="boss-layout-block">
    <table class="boss-table-4 boss-table-4-custom">
      <tr>
        <th rowspan="2">
          候補日時
        </th>
        <td data-test="first-candidate-date">
          第一候補 {{ candidateDates[0] | formatDate }}
        </td>
      </tr>
      <tr>
        <td data-test="second-candidate-date">
          第二候補 {{ candidateDates[1] | formatDate('指定なし') }}
        </td>
      </tr>
      <tr
        v-if="place"
        data-test="place-tr"
      >
        <th>場所</th>
        <td data-test="place">
          {{ place }}
          <a
            v-if="isShowGoogleMapLink"
            data-test="google-map-place"
            :href="encodeURI(`https://maps.google.co.jp/?q=${googleMapPlace}`)"
            target="_blank"
          >[map]</a>
        </td>
      </tr>
      <tr>
        <th>所要時間</th>
        <td data-test="duration">
          {{ duration | formatMinutes }}
        </td>
      </tr>
      <tr
        v-if="contentNames && contentNames.length"
        data-test="contents-tr"
      >
        <th>内容</th>
        <td data-test="contents">
          {{ contentNames | formatJoinComm }}
        </td>
      </tr>
      <tr
        v-if="remarks"
        data-test="remarks-tr"
      >
        <th>備考</th>
        <td
          class="pega-pre-wrap pega-break-all"
          data-test="remarks"
          v-text="remarks"
        />
      </tr>
    </table>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import _ from 'lodash'
import util from '@/lib/util'

export default {
  filters: {
    formatDate (val, defaultLabel = '') {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : defaultLabel
    },
    formatMinutes (val) {
      return val ? `${val}分` : '指定なし'
    },
    formatJoinComm (val) {
      return _.join(val, '、')
    }
  },
  props: {
    candidateDates: {
      type: Array,
      default: () => []
    },
    place: {
      type: String,
      default: ''
    },
    googleMapPlace: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: undefined
    },
    contentNames: {
      type: Array,
      default: () => []
    },
    remarks: {
      type: String,
      default: ''
    }
  },
  computed: {
    isShowGoogleMapLink () {
      return this.googleMapPlace && !util.includeUrl(this.googleMapPlace)
    }
  }
}
</script>
